export default __webpack_public_path__ + "static/media/isLogo.db055405.bmp";